angular
  .module('contrast.directives.navselect', [])
  .directive('navSelect', function ($, $filter, $location) {
    'ngInject'

    var initialRoute = null

    function getRoutes(routeElements, scope) {
      var el = null,
        routes = [],
        len = routeElements.length,
        i = 0

      for (; i < len; i++) {
        el = $(routeElements[i])

        var route = {
          route: el.attr('route'),
          path: el.attr('params')
            ? scope.$eval(
                "'" +
                  el.attr('route') +
                  "' | routeSegmentUrl: " +
                  el.attr('params')
              )
            : null,
          title: el.attr('title')
        }

        if ($filter('routeSegmentStartsWith')(route.route)) {
          initialRoute = route
        }

        routes.push(route)
      }

      return routes
    }

    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      templateUrl: 'views/common/nav-select.html',
      link: function ($scope, ele) {
        var transclude = ele.find('ng-transclude')

        $scope.$watch(
          function () {
            return transclude.find('nav-route').length
          },
          function (newValue, oldValue) {
            if (newValue != oldValue) {
              $scope.routes = getRoutes(transclude.find('nav-route'), $scope)
            }
          }
        )

        angular.extend($scope, {
          routes: getRoutes(transclude.find('nav-route'), $scope),
          currentRoute: initialRoute,

          navSelected: function (item) {
            if (item.path) {
              $location.path(item.path)
            }
          }
        })
      }
    }
  })
